import { render, staticRenderFns } from "./LayAllJournalList.vue?vue&type=template&id=3b99a89c&scoped=true&"
import script from "./LayAllJournalList.vue?vue&type=script&lang=js&"
export * from "./LayAllJournalList.vue?vue&type=script&lang=js&"
import style0 from "./LayAllJournalList.vue?vue&type=style&index=0&id=3b99a89c&lang=less&scoped=true&"
import style1 from "./LayAllJournalList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b99a89c",
  null
  
)

export default component.exports